/*
 * @method map
 * Combines a new state object based on given mapState functions
 */
export const combineStates = function () {
  if ( arguments.length < 1 ) {
    throw new Error( 'Expected at least 1 arguments' );
  }
  
  let args = Array.prototype.slice.call( arguments );
  for( let i = 0; i < args.length; i++ ) {
    if( typeof args[i] === 'string' ) {
      throw new Error( 'string arguments are not allowed' );
    }
  }  
  return state => args.reduce( ( current, item ) => !item ? current : Object.assign( current, item && item.apply ? item( state ) : item ), { } );
};